import { RootState } from "@/modules/common";

export const selectTotalPrice = (state: RootState) =>
  state.basket.basket.totalPrice;
